import React, { Component } from 'react';
import Section from "./components/Section";
import {lightGradient} from "./Helpers";
import {MD_BREAKPOINT, SM_BREAKPOINT} from "../../../Constants/Constants";
import Media from "react-media";
import SkillsChart from './components/HorizontalBar';

class Skills extends Section {

	constructor(props) {
		super(props);
		//console.log("About Constructor", props);
		this.aboutRef = React.createRef();
	}

	componentDidMount() {
		this.props.updateRef(this.props.title, this.aboutRef);
	}

	styles = {
		...Section.styles,
		mainContainer: {
			...Section.styles.mainContainer,
			// background: "url(" + IMAGES_DIR + "/home.jpg)",
			// backgroundSize: "cover",
			textAlign: "left",
			backgroundImage: (this.props.backgroundColor ? lightGradient(this.props.backgroundColor) : "#fff"),
			backgroundAttachment: 'fixed',
		},
		contentContainer: {
			...Section.styles.contentContainer,
			padding: "auto",
			minHeight: "100vh",
			display: "flex",
			flexDirection: "column",
			fontSize: '1rem',
			// alignContent: "center",
			// justifyContent: "center",
			// alignItems: "center",
		},
		title: {
			textAlign: "center",
			...Section.styles.title,
			fontStyle: "bold",
		},
		subTitle: {
			...Section.styles.subTitle,
			maxWidth: "90%",
			textAlign: "left",
		},
	};

	render() {
		let allSkills = [];

		for(let i=0; i<this.props.data.length; i++){
			// console.log(allSkills, this.props.data[i].data)
			allSkills = [...allSkills, ...this.props.data[i].data];
		}


		// this.props.data.forEach(item=>{
		// 	allSkills.concat(item.data);
		// });
		return (
			<div style={this.styles.mainContainer} ref={this.aboutRef}>
				<div style={this.styles.contentContainer}>
					<h1 style={this.styles.title}>{this.props.title}</h1>
					{this.props.subtitle ? <h2 style={this.styles.subTitle}>{this.props.subtitle}</h2> : null}
					<div style={{display: "flex", flexDirection: "column"}}>
						<List
							styles={this.styles}
							data={allSkills}
							window_width={this.props.window_width}
						/>
					</div>
					<Media query={`(min-width: ${SM_BREAKPOINT}px)`}>
					{
						matches => matches ?
							(
								<div style={{display: "flex", flexDirection: "column", paddingBottom: "2rem", }}>
									<SkillsChart 
										isHorizontal
										skills={allSkills}
									/>
								</div>
							)
							:
							(
								<div style={{display: "flex", flexDirection: "column", paddingBottom: "0.5rem", }}>
									<SkillsChart
										skills={allSkills}
									/>
								</div>
							)
					}
					</Media>
					<div className="text-muted text-center" style={{fontSize: "0.5rem", display: "flex", flexDirection: "column", paddingBottom: "2rem", }}>
						Note: Rating values are random numbers used only for the sake of vizualization.
					</div>
				</div>
			</div>
		);
	}
}

class SkillItem extends Component {
	constructor(props){
		super(props);
		let targetWidth = parseInt(Math.random()*100);
		let id= parseInt(Math.random()*Math.pow(10, 20)).toString(36);
		let r = (parseInt(Math.random()*1000)-128)%256;
		let g = (parseInt(Math.random()*1000)-128)%128;
		let b = (parseInt(Math.random()*1000)-128)%128;
		let alpha = 0.1;//Math.random()%0.5;
		this.state = {
			hover: false,
			targetWidth,
			id,
			width: 0,
			r, g, b, alpha
		}
	}

	componentDidMount(){
		// let {r, g, b, alpha} = this.state;

		// console.log(`rgba(${r},${g},${b},${alpha})`)
		// document.addEventListener('scroll', (e)=>{

		// })
	}

	componentWillUnmount() {
		// document.removeEventListener('scroll');
	}

	render(){
		let {r, g, b, alpha} = this.state;
		return (
			<div className="px-2 m-2" onMouseEnter={(e)=>{
				this.setState({hover: true})
			}} 
			onMouseLeave={(e)=>{
				this.setState({hover: false})
			}} >
				<div 
				style={{
					position: 'relative', 
				}} id={this.state.id}>
				<div 
				
				style={{
					border: this.state.hover ? null : `1px solid rgb(${r},${g},${b})`,
					boxShadow: this.state.hover ? 
						`0px 0px 10px 0px rgba(${r},${g},${b},0.5)` : 
						`0px 0px 10px 0px rgba(${r},${g},${b},0.1)`,
					borderRadius: "0.1rem",
					// borderRadius: this.state.hover ? ".5rem" : "0.1rem",
					zIndex: -1,
					position: "absolute", 
					top:"0", 
					width: '100%',
					height: '100%',
					// width:`${this.state.targetWidth}%`,
					background: this.state.hover ? `rgba(${r},${g},${b},0.3)` : `rgba(${r},${g},${b},${alpha})`,
					// transform: this.state.hover ? "scale(1.5)" : "scale(1)",
					transition: "all 0.2s ease-in-out"	
				}}></div>
				<div className="text-center" style={{
					zIndex: 10, 
					fontWeight: this.state.hover ? 'inherit' : '400',
					maxWidth: '320px', 
					width: "100%",
					padding: "0.25rem 1rem",
					transition: "0.1s ease-in-out",
					fontSize: '1rem',
				}}>
					{this.props.skill}
				</div>
			</div>
			</div>
		)
	}
}

export const List = (props) => (
	<div style={{
		display: "flex",
		flexDirection: "column",
		margin: "0.5rem",
	}}>
		<div 
			style = {{
				zIndex: 1,
				top:"0", 
				marginBottom: "2rem",
			}}
			className="d-flex flex-wrap justify-content-between align-items-center"	
		>
			{props.data.map((item, index) => <SkillItem key={index} skill={item}/>)}
		</div>
	</div>
);

export default Skills;